import { render, staticRenderFns } from "./CommentPhoto.vue?vue&type=template&id=79f6af28&"
import script from "./CommentPhoto.vue?vue&type=script&lang=js&"
export * from "./CommentPhoto.vue?vue&type=script&lang=js&"
import style0 from "./CommentPhoto.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports